import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withTranslation, Trans } from "react-i18next";
import { appService } from "services";
import { errorFormating } from "utils/utils";
import Loading from "components/Loading";
import Logo from "components/Logo";
import { transLnkComponents } from "utils/i18nComponents";

class DuplicatedEmail extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			isConfirmed: false,
			errors: {},
		};
	}

	async componentDidMount() {
		const response = await appService.confirmDuplicatedEmail(
			this.props.match.params.token
		);

		this.setState({
			isLoading: false,
			isConfirmed: Boolean(response.ok),
			errors: response.ok ? {} : errorFormating(response),
		});
	}

	getErrorMessage() {
		const { errors } = this.state;
		return (
			errors.general ||
			errors["duplicated-email-confirmation-token"] ||
			this.props.t("duplicatedEmail.invalidToken")
		);
	}

	getContent() {
		if (this.state.isLoading) return <Loading />;

		if (this.state.isConfirmed) {
			return (
				<div className="alert alert-success fade show" role="alert">
					<Trans
						i18nKey="duplicatedEmail.successMessage"
						components={transLnkComponents.login}
					/>
				</div>
			);
		}

		return (
			<div className="notfound container-sm">
				<h3>:(</h3>
				<p>{this.getErrorMessage()}</p>
				<p>
					<Trans
						i18nKey="duplicatedEmail.goToLogin"
						components={transLnkComponents.login}
					/>
				</p>
			</div>
		);
	}

	render() {
		const { t } = this.props;
		return (
			<div className="Auth">
				<div className="remember-block">
					<div className="login-container">
						<Link to="/">
							<Logo className="logo" type="logo" />
						</Link>
						<div className="login-title">{t("duplicatedEmail.title")}</div>
						{this.getContent()}
					</div>
				</div>
			</div>
		);
	}
}

export default withTranslation()(DuplicatedEmail);
